export default {
    key: 'unlimited-pass-summer',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: 'cd7cc14a-3749-486c-9364-8a9b89266219',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: true,
    isUsingKeyCards: true,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: undefined,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'cd7cc14a-3749-486c-9364-8a9b89266219',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-unlimited-pass-summer-steps-step-1-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
        },
    ],
} satisfies ProductConfigActivity;
